/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferralRecipientInput
 */
export interface ReferralRecipientInput {
    /**
     * Recipient identifier — either a real provider_directory row or a hardcoded allowlist facility's synthetic id. Omit entirely for an "other" recipient (a name+email contact not backed by either).
     * @type {string}
     * @memberof ReferralRecipientInput
     */
    provider_id?: string;
    /**
     * The referral_recipient_config's own id. Required when provider_id is omitted — this (not email) is an "other" recipient's routing identity downstream, since email alone isn't safe to expose as a URL/analytics-visible identifier.
     * @type {string}
     * @memberof ReferralRecipientInput
     */
    recipient_config_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientInput
     */
    email?: string;
    /**
     * Recipient name. Required when provider_id is omitted.
     * @type {string}
     * @memberof ReferralRecipientInput
     */
    display_name?: string;
}

/**
 * Check if a given object implements the ReferralRecipientInput interface.
 */
export function instanceOfReferralRecipientInput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReferralRecipientInputFromJSON(json: any): ReferralRecipientInput {
    return ReferralRecipientInputFromJSONTyped(json, false);
}

export function ReferralRecipientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRecipientInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'recipient_config_id': !exists(json, 'recipient_config_id') ? undefined : json['recipient_config_id'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
    };
}

export function ReferralRecipientInputToJSON(value?: ReferralRecipientInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'provider_id': value.provider_id,
        'recipient_config_id': value.recipient_config_id,
        'email': value.email,
        'display_name': value.display_name,
    };
}

